import { InvalidRowState } from "./types";
import { SectionHeader } from "./shared";
import { InvalidMappingRow } from "./InvalidMappingRow";

interface InvalidMappingsSectionProps {
    invalidRows: InvalidRowState[];
    validPermutations: string[];
    onReplacementChange: (index: number, value: string) => void;
    onUpdate: (index: number) => void;
    onDelete: (index: number) => void;
}

export const InvalidMappingsSection = ({
    invalidRows,
    validPermutations,
    onReplacementChange,
    onUpdate,
    onDelete,
}: InvalidMappingsSectionProps) => (
    <section>
        <SectionHeader label="Invalid Mappings" count={invalidRows.length} status="bad" />
        <p className="text-xs text-stone-400 mb-3">
            These mappings reference a permutation that no longer exists on the updated line item.
        </p>
        <div className="space-y-3">
            {invalidRows.map((row, index) => (
                <InvalidMappingRow
                    key={row.mapping.id}
                    row={row}
                    validPermutations={validPermutations}
                    onReplacementChange={(value) => onReplacementChange(index, value)}
                    onUpdate={() => onUpdate(index)}
                    onDelete={() => onDelete(index)}
                />
            ))}
        </div>
    </section>
);
